// The iOS and Android WebViews set this once per access token and then leave sessionStorage
// alone, so an Auth0 round trip can find the sign-in state the page stored. An app that still
// clears sessionStorage on every load never sets it.
export const APP_SESSION_MARKER_KEY = 'zbAppSession';

export const appKeepsSignInState = () => {
  try {
    return Boolean(sessionStorage.getItem(APP_SESSION_MARKER_KEY));
  } catch {
    return false;
  }
};
